module.exports = __webpack_public_path__ + "a768e7de/img/splash-icon.07a7c465.svg";